function matchHeights() {
	var options = {
		byRow: false,
		byRow: true,
		property: 'min-height',
		target: null,
		remove: false
	};

	$('.history-block .content-tile').matchHeight(options);
	$('.assets-protect .carouselResource .resource-content h3').matchHeight(options);
	$('.assets-protect .carouselResource .resource-content p').matchHeight(options);
	$('.block-imageContent_tilesCarousel .cards .card-block .content-block').matchHeight(options);
	

	function TabMatchHeight(){
		$('.nav-tabs li a').on('shown.bs.tab', function (event) {
			$('.tab-content .cards .card-block').matchHeight(options);
		});
	}
	TabMatchHeight();


	$(window).on("load", function () {
		TabMatchHeight();
	});
}

matchHeights();
// 
// $(document).ready(function () {
// 	// Initialize matchHeight for your elements initially
// 	$('.assets-protect .carouselResource .resource-content h3').matchHeight(options);
// 	$('.assets-protect .carouselResource .resource-content p').matchHeight(options);
  
// 	// Listen for Bootstrap accordion events
// 	$('.assets-protect .carouselResource').on('show.bs.collapse hide.bs.collapse', function () {
// 	  // When a panel is shown or hidden, reinitialize matchHeight for the elements within that panel
// 	  $(this).find('.resource-content h3').matchHeight('update');
// 	  $(this).find('.resource-content p').matchHeight('update');
// 	});
//   });
  
